import { Component, EventEmitter, Input, Output } from '@angular/core'
import { HelperService } from '../../../../../services/helper.service'
import { IDataCardPT } from '../../../../../models/data-card.model'
import { NotificationsDataCardModalComponent } from '../../cmms-components/notifications-data-card-modal/notifications-data-card-modal.component'
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap'
import { SoraItemModalComponent } from '../../sora-components/sora-item-modal/sora-item-modal.component'
import { BasicAuthService } from '../../../../../services/basic-auth.service'

@Component({
  selector: 'app-data-process-transmitters',
  templateUrl: './data-process-transmitters.component.html',
  standalone: false,
})
export class DataProcessTransmittersComponent {
  @Input() data: IDataCardPT
  @Input() filter?: { startTime?: string; endTime?: string }
  @Input() hasCMMSPackage: boolean = false
  @Input() hasRCAFPackage: boolean = false

  @Output() openSDLEvent: EventEmitter<string> = new EventEmitter()

  constructor(
    private modalService: NgbModal,
    private authService: BasicAuthService,
  ) {}

  public getSIFParams(mo: string): any {
    return {
      filter: JSON.stringify(
        HelperService.getObjectWithoutNullValues({
          initiator: mo,
        }),
      ),
    }
  }

  public onOpenNotificationModal(tag: string): void {
    const modalRef: NgbModalRef = this.modalService.open(NotificationsDataCardModalComponent, {
      windowClass: 'cmms-notification-modal-z2000',
      backdropClass: 'cmms-notification-backdrop-z2000',
    })
    modalRef.componentInstance.mainObject = tag
  }

  public displayNotificationIcon(notificationStatus?: number): boolean {
    return this.hasCMMSPackage && (notificationStatus === -1 || notificationStatus === 1)
  }

  public hasUrlBadges(): boolean {
    return !!(
      this.data &&
      (this.data.Dev_Active ||
        this.data.Dev_InActive_Count ||
        this.data.Flt_Active ||
        this.data.Flt_InActive_Count)
    )
  }

  public onOpenSDL(sdl: string): void {
    this.openSDLEvent.next(sdl)
  }

  public getSDLs(sdl?: string): string[] {
    if (sdl) {
      return sdl.split(',').map((item: string) => item.trim())
    }
    return []
  }

  public displaySORA(tagHasSora: boolean): boolean {
    return this.authService.hasSORAPackage() && tagHasSora
  }

  public onOpenSORAModal(tag: string): void {
    const modalRef: NgbModalRef = this.modalService.open(SoraItemModalComponent, {
      windowClass: 'cmms-notification-modal-z2000',
      backdropClass: 'cmms-notification-backdrop-z2000',
    })
    modalRef.componentInstance.mainObject = tag
  }
}


